import createTimePicker from './time-picker';
import dayjsGenerateConfig from '../vc-picker/generate/dayjs';
const { TimePicker, TimeRangePicker } = createTimePicker(dayjsGenerateConfig);
/* istanbul ignore next */
TimePicker.install = function (app) {
    app.component(TimePicker.name, TimePicker);
    app.component(TimeRangePicker.name, TimeRangePicker);
    return app;
};
TimePicker.TimeRangePicker = TimeRangePicker;
export { TimePicker, TimeRangePicker };
export default TimePicker;
